
Greenmile.PendingOrdersNotification = Greenmile.PendingOrdersNotification || {};

Greenmile.PendingOrdersNotification.Utils = {

    fieldsToProjection: [
        { 'name': 'number' },
        { 'name': 'createdDate' },
        { 'name': 'location.*' },
        { 'name': 'priority' },
        { 'name': 'plannedSize1' },
        { 'name': 'plannedPickupSize1' },
        { 'name': 'specialInstructions' }
    ],

    filterBasic: {
        "criteriaChain": [{
            "and": [{
                "attr": "assignedBy",
                "isNull": true
            }, {
                "attr": "assignedDate",
                "isNull": true
            }, {
                "attr": "assignedOrder",
                "isNull": true
            }]
        }]
    }
};